import AuthGuard from "utils/route-guard/AuthGuard";
import Loadable from "components/Loadable";
// project-imports
import MainLayout from "layout/MainLayout";
import { lazy } from "react";

// render - admin
const Dashboard = Loadable(lazy(() => import("pages/dashboard")));
const Notifications = Loadable(lazy(() => import("pages/notifications")));

// render - bulk messages
// const SendMessage = Loadable(lazy(() => import("pages/bulk-messaging/send-message")));
const SendSMS = Loadable(lazy(() => import("pages/bulk-messaging/send-message/sms")));
const SendEmail = Loadable(lazy(() => import("pages/bulk-messaging/send-message/email")));
const SentMessages = Loadable(lazy(() => import("pages/bulk-messaging/sent-messages")));
const ScheduledMessages = Loadable(lazy(() => import("pages/bulk-messaging/scheduled-messages")));
const MessageSummary = Loadable(lazy(() => import("pages/bulk-messaging/summary")));
const AnniversaryAlerts = Loadable(lazy(() => import("pages/bulk-messaging/schedule-message")));
const AnniversaryVoice = Loadable(lazy(() => import("pages/bulk-messaging/schedule-message/schedule")));
// const AudioLibrary = Loadable(lazy(() => import("pages/bulk-messaging/audio-library")));
const IvrCampaigns = Loadable(lazy(() => import("pages/bulk-messaging/ivr-campaigns")));
const SenderId = Loadable(lazy(() => import("pages/bulk-messaging/senderids")));
const ScheduledMessageSummary = Loadable(lazy(() => import("pages/bulk-messaging/schedule-message/schedule/summary")));
const SmsTemplates = Loadable(lazy(() => import("pages/sms-templates")));

// render - address book
const Contacts = Loadable(lazy(() => import("pages/address-book/contacts")));
const ManageGroups = Loadable(lazy(() => import("pages/address-book/manage-groups/index")));
const GroupDetails = Loadable(lazy(() => import("pages/address-book/manage-groups/Details")));
const BulkImports = Loadable(lazy(() => import("pages/address-book/bulk-imports")));

// render - User Credits
const CreditInvoiceList = Loadable(lazy(() => import("pages/credits/invoices")));
const Bundle = Loadable(lazy(() => import("pages/credits/bundles")));
const Balance = Loadable(lazy(() => import("pages/credits/balance")));
const Profile = Loadable(lazy(() => import("pages/profile")));
const InvoiceDetails = Loadable(lazy(() => import("pages/credits/invoices/details")));
// const PaymentCallback = Loadable(lazy(() => import("pages/payment-callback")));

const Error500 = Loadable(lazy(() => import("pages/maintenance/error/500")));
const Error403 = Loadable(lazy(() => import("pages/maintenance/error/403")));
const Error404 = Loadable(lazy(() => import("pages/maintenance/error/404")));

const SessionExpired = Loadable(lazy(() => import("pages/maintenance/error/sessionexpired")));
const AccountSettings = Loadable(lazy(() => import("pages/account-settings")));
const UserProfile = Loadable(lazy(() => import("pages/account-settings/account")));
const SenderApi = Loadable(lazy(() => import("pages/account-settings/apirequest")));
const ClientPassword = Loadable(lazy(() => import("pages/account-settings/password")));

//USSD
const ShortCodes = Loadable(lazy(() => import("pages/ussd/shortcodes")));
const Subscriptions = Loadable(lazy(() => import("pages/ussd/subscription")));
const Campaigns = Loadable(lazy(() => import("pages/ussd/campaign")));
const CampaignsData = Loadable(lazy(() => import("pages/ussd/campaign/campaign-table")));
const USSDFlow = Loadable(lazy(() => import("pages/ussd/flow")));
const USSDFlowBuilder = Loadable(lazy(() => import("pages/ussd/ussd-flow")));
const IVRFlowBuilder = Loadable(lazy(() => import("pages/voice/ivr-flow")));
const VoiceCampaigns = Loadable(lazy(() => import("pages/voice/campaigns")));
const Responses = Loadable(lazy(() => import("pages/voice/responses")));
// const Voice = Loadable(lazy(() => import("pages/voice")));
const VoiceAudioLibrary = Loadable(lazy(() => import("pages/voice/audio-library")));
// const OldAudioLibrary = Loadable(lazy(() => import("pages/bulk-messaging/audio-library")));
const IVR = Loadable(lazy(() => import("pages/bulk-messaging/ivr-campaigns")));
const CallerIdSubscription = Loadable(lazy(() => import("pages/subscriptions/callerids")));
const SubscribedCallerIds = Loadable(lazy(() => import("pages/subscriptions/callerid-subscriptions")));

const ClientRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: (
        <AuthGuard allowedRoles={["CLIENT"]}>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        // {
        //   path: "payment-callback/",
        //   element: <PaymentCallback />
        // },
        {
          path: "dashboard",
          element: <Dashboard />
        },
        {
          path: "notifications",
          element: <Notifications />
        },
        {
          path: "bulk-messaging",
          children: [
            // {
            //   path: "send-message",
            //   element: <SendMessage />
            // },
            {
              path: "send-message",
              element: <SendSMS />
            },

            {
              path: "send-message/email",
              element: <SendEmail />
            },

            // {
            //   path: "sms",
            //   element: <SendSMS />
            // },

            {
              path: "sent-messages",
              element: <SentMessages />
            },
            {
              path: "scheduled-messages",
              element: <ScheduledMessages />
            },
            {
              path: "summary",
              element: <MessageSummary />
            },
            {
              path: "schedule-a-message",
              element: <AnniversaryAlerts />
            },
            {
              path: "schedule-a-message/schedule",
              element: <AnniversaryVoice />
            },
            {
              path: "scheduled-a-messages/summary",
              element: <ScheduledMessageSummary />
            },

            {
              path: "ivr-campaigns",
              element: <IvrCampaigns />
            },
            {
              path: "ivr-campaigns",
              element: <IvrCampaigns />
            },
            {
              path: "senderids",
              element: <SenderId />
            },
            {
              path: "senderids/:id",
              element: <SenderId />
            },
            {
              path: "sms-templates",
              element: <SmsTemplates />
            }
          ]
        },
        {
          path: "campaigns",
          children: [
            {
              path: "voice",
              element: <VoiceCampaigns />
            },
            {
              path: "flow",
              element: <IVRFlowBuilder />
            },
            {
              path: "flow/:id",
              element: <IVRFlowBuilder />
            },
            {
              path: "responses",
              element: <Responses />
            }
          ]
        },
        {
          path: "address-book",
          children: [
            {
              path: "contacts",
              element: <Contacts />
            },
            {
              path: "groups",
              element: <ManageGroups />
            },
            {
              path: "manage-group/:groupid",
              element: <GroupDetails />
            },
            {
              path: "bulk-imports",
              element: <BulkImports />
            }
          ]
        },
        {
          path: "credits",
          children: [
            {
              path: "balance",
              element: <Balance />
            },
            {
              path: "bundles",
              element: <Bundle />
            },
            {
              path: "invoices",
              element: <CreditInvoiceList />
            },
            {
              path: "invoices/view/:invoiceid",
              element: <InvoiceDetails />
            }
          ]
        },
        {
          path: "ussd",
          children: [
            {
              path: "flow",
              element: <USSDFlow />
            },
            {
              path: "flow-builder",
              element: <USSDFlowBuilder />
            },
            {
              path: "flow-builder/:id",
              element: <USSDFlowBuilder />
            },
            {
              path: "shortcodes",
              element: <ShortCodes />
            },
            {
              path: "subscriptions",
              element: <Subscriptions />
            },
            {
              path: "campaigns/:id",
              element: <Campaigns />
            },
            {
              path: "campaign/table/:id",
              element: <CampaignsData />
            }
          ]
        },
        {
          path: "voice",
          children: [
            // {
            //   path: "start",
            //   element: <Voice />
            // },
            // {
            //   path: "flow",
            //   element: <AudioFlow />
            // },
            {
              path: "audio-library",
              element: <VoiceAudioLibrary />
            },
            // {
            //   path: "old-audio-library",
            //   element: <OldAudioLibrary />
            // },
            {
              path: "ivr",
              element: <IVR />
            }
          ]
        },
        {
          path: "subscriptions",
          children: [
            {
              path: "callerids",
              element: <CallerIdSubscription />
            },
            {
              path: "subscribed-callerids",
              element: <SubscribedCallerIds />
            }
          ]
        },
        {
          path: "user",
          children: [
            {
              path: "profile",
              element: <Profile />
            },
            {
              path: "profile/:client_id",
              element: <Profile />
            },
            {
              path: "account-settings",
              element: <AccountSettings />,
              children: [
                {
                  path: "password",
                  element: <ClientPassword />
                },
                {
                  path: "account",
                  element: <UserProfile />
                },
                {
                  path: "apidetails",
                  element: <SenderApi />
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "403",
      element: <Error403 />
    },
    {
      path: "404",
      element: <Error404 />
    },
    {
      path: "500",
      element: <Error500 />
    },
    {
      path: "session-expired",
      element: <SessionExpired />
    }
  ]
};

export default ClientRoutes;
